
import { defineComponent, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { services } from '@/services/services'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { useStore } from 'vuex'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'

const service = services.clearCache

export default defineComponent({
  components: {
    ResponseResultAlert,
    LoadingButton,
    ContentLayout
  },
  setup () {
    const requestError = ref<string | null>(null)
    const loading = ref(false)
    const isSucceed = ref(false)
    const store = useStore()

    const onClickedExport = async () => {
      loading.value = true
      isSucceed.value = false
      const start = store.state.accountingStartDate
      const end = store.state.accountingEndDate
      await callApiWrapper(requestError, async () => {
        await service.clearKamokuCache(start, end)
        isSucceed.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceed.value = false
      requestError.value = null
    }

    return {
      onClickedExport,
      onDismissAlert,
      loading,
      isSucceed,
      requestError
    }
  }
})
